module.exports = __webpack_public_path__ + "static/media/scrollLeft2.00729662.png";